module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "player"
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "webkit-playsinline": ""
    }
  }, [(_vm.url) ? _c('source', {
    attrs: {
      "src": _vm.url,
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('fullscreen-control', {
    attrs: {
      "video": _vm.video
    }
  }), _vm._v(" "), _c('overlay-play', {
    attrs: {
      "video": _vm.video
    }
  }), _vm._v(" "), _c('timeline-slider', {
    attrs: {
      "video": _vm.video
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91e527e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/player/Player.vue
// module id = 203
// module chunks = 1